export enum CookieKey {
  REDIRECT_URL = 'REDIRECT_URL_v3',
  USER = 'MMMM_U_365_V14',
  TAG_FILTERS = 'TAG_FILTERS_V3',
  SHOW_IMAGE_SELECT_MODAL = 'SHOW_IMAGE_SELECT_MODAL_v1'
}
